import type { FC, PropsWithChildren, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';
import { RoutePathsE } from 'declarations/enums/routes';
import useLocationStore from 'hooks/store/useLocationStore';

const RequireAuth: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const { isUserLoggedIn } = useAuth();
  const { pathname: pathName, search } = useLocation();
  const setLocation = useLocationStore(state => state.setLocation);

  if (!isUserLoggedIn) {
    setLocation({ pathName, search });

    return <Navigate to={RoutePathsE.LOGIN_PAGE} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
